<!-- This wrapper shows the background without any animations on it-->
<div class="backGroundWrapper">

  <!--
  We need the fadeIn animation on the container
  to prevent the slideOutLeft animation from running at the initial render.
  -->
  <div class="contentWrapper" @fadeIn>

    <!-- Keep the groups on screen to store the scrollPosition? -->

    <tun-search-music-channels-view
      [@viewPosition]="mainViewPosition$ | async"
      class="fullContainer">
    </tun-search-music-channels-view>

    @if ((searchView$ | async) == SEARCH_VIEW.SEARCH_VIEW_RESULTS) {
      <tun-search-result-view
    [@carousel]="{
      value: animationDirection,
      params: {
        duration: CAROUSEL_DURATION
      }
    }"
      class="fullContainer">
    </tun-search-result-view>
  }


  <!--
  <tun-search-music-channels-view
    *ngIf="(searchView$ | async) == SEARCH_VIEW.SEARCH_VIEW_MAIN"
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  class="fullContainer">
</tun-search-music-channels-view>
-->
@if ((searchView$ | async) == SEARCH_VIEW.SEARCH_VIEW_TEXT_RESULTS) {
  <tun-search-text-view
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  (@carousel.start)="textViewAnimationStart($event)"
  (@carousel.done)="textViewAnimationDone($event)"
  [canReceiveFocus]="!textViewIsAnimating"
  (back)="onCloseSearchText()"
  class="fullContainer">
</tun-search-text-view>
}


@if ((searchView$ | async) == SEARCH_VIEW.SEARCH_VIEW_RESULT_MUSIC_COLLECTION) {
  <tun-search-music-collection-result-view
  [@carousel]="{
    value: animationDirection,
    params: {
      duration: CAROUSEL_DURATION
    }
  }"
  class="fullContainer"
  >
</tun-search-music-collection-result-view>
}

@if (!(accessToSearch$ | async)) {
  <tun-access-right-overlay-view
    class="fullContainer"
    [message]="'accessRight.screen.search' | translate">
  </tun-access-right-overlay-view>
}



</div>


</div>
